import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './AdminPinModal.css';
import API_BASE_URL from '../../config/api';

const AdminPinModal = ({ isOpen, targetUserId, onSuccess, onClose }) => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [forgotPinSent, setForgotPinSent] = useState(false);
  const [sendingForgot, setSendingForgot] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setPin('');
      setError('');
      setForgotPinSent(false);
      setTimeout(() => {
        if (inputRef.current) inputRef.current.focus();
      }, 100);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pin.length !== 4) {
      setError('O PIN deve ter 4 dígitos.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/auth/verify-admin-pin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ targetUserId, pin })
      });

      if (response.ok) {
        onSuccess();
        setPin('');
      } else {
        const err = await response.json();
        setError(err.message || 'PIN incorreto. Tente novamente.');
        setPin('');
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }
    } catch (err) {
      console.error('Error verifying PIN:', err);
      setError('Erro de ligação ao servidor.');
      setPin('');
      if (inputRef.current) {
        inputRef.current.focus();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPin = async () => {
    if (!targetUserId || sendingForgot) return;
    setSendingForgot(true);
    try {
      const token = localStorage.getItem('token');
      await fetch(`${API_BASE_URL}/api/auth/forgot-pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ targetUserId }),
      });
      setForgotPinSent(true);
    } catch {
      setError('Erro ao enviar email. Tente novamente.');
    } finally {
      setSendingForgot(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="admin-pin-modal-overlay" onClick={onClose}>
      <div className="admin-pin-modal" onClick={e => e.stopPropagation()}>
        <div className="admin-pin-modal-header-premium">
          <img src="/CDP_logo.png" alt="CDP Logo" className="admin-pin-logo" />
          <h3>ACESSO RESTRITO</h3>
          <p>Insira o PIN de 4 dígitos</p>
        </div>
        <div className="admin-pin-modal-body">
          <form onSubmit={handleSubmit}>
            <input
              ref={inputRef}
              type="password"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
              placeholder="••••"
              disabled={isLoading}
              className={error ? 'error' : ''}
              autoComplete="off"
            />
            {error && <div className="admin-pin-error">{error}</div>}
            <button
              type="submit"
              className="admin-pin-submit-btn"
              disabled={isLoading || pin.length !== 4}
            >
              {isLoading ? 'A verificar...' : 'Aceder'}
            </button>
            <button
              type="button"
              className="admin-pin-cancel-btn"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancelar
            </button>
          </form>
          <div className="admin-pin-forgot">
            {forgotPinSent ? (
              <span className="admin-pin-forgot-sent">✉️ Email enviado! Verifique a sua caixa de entrada.</span>
            ) : (
              <button
                type="button"
                className="admin-pin-forgot-btn"
                onClick={handleForgotPin}
                disabled={sendingForgot}
              >
                {sendingForgot ? 'A enviar...' : 'Esqueceu do seu PIN?'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AdminPinModal;
